import { useAppSelector } from 'app/store';
import { selectUserCompanies } from 'app/store/userCompaniesSlice';

/**
 * Whether the selected paidol routes transactions through group approvers.
 *
 * Mirrors group_approvals_enabled in the Amplify and CDK Python. Read by the
 * chips: with it on, the step a review lands on is named for what it awaits
 * across the whole account, whether or not the row's own group adds steps.
 */
export const useGroupApprovalsEnabled = (): boolean =>
  useAppSelector(selectUserCompanies).selectedPaidol?.approvalWorkflowSettings?.groupApprovalsEnabled ===
  true;
